
<template>
    <div>
        <mars-view class="law-activity-box"><top-bar :logo-url="topBarStyle.logoUrl" :back-icon-color="topBarStyle.textColor" :home-icon-color="topBarStyle.textColor" :bg-color="topBarStyle.bgColor" :home-flag="true" :no-blank="true"></top-bar><mars-view class="main-content-box"><mars-view v-for="item,index in list" :key="index" :class="['content-item-box']"><mars-view v-if="item.selectType === 'header_pic'" :id="item.selectType"><ui-header :swiper-list="headerSwiperList" :info="item"></ui-header></mars-view><mars-view v-if="item.selectType === 'form_sub_new'" :id="item.selectType" class="form-sub-box"><clue-form :is-show-close="false" :info="item.form_sub_new && item.form_sub_new.elements || []" :optype="item.optype" :com-type="item.selectType" :form-info="formInfo" :query-info="queryInfo" :is-btn-bottom="false" part-from="form" @formChange="formChange" @successSubmit="successSubmit"></clue-form></mars-view><mars-view v-if="item.selectType === 'legal_qa'" :id="item.selectType"><knowledge-list :info="item"></knowledge-list></mars-view><mars-view v-if="item.selectType === 'bottom_layer' && isFormBtnShow === false" :id="item.selectType"><fixed-btn :info="item.bottom_layer && item.bottom_layer.popup_elements || []" :btn-info="item.bottom_layer && item.bottom_layer.button || {}" :com-type="item.selectType" :form-info="formInfo" :optype="item.optype" :query-info="queryInfo" @formChange="formChange" @showPop="showPop" @successSubmit="successSubmit"></fixed-btn></mars-view><mars-view v-if="item.selectType === 'popup'" :id="item.selectType"><clue-popup :info="item.popup && item.popup.elements || []" :show="isShowBackPop" :form-info="formInfo" :query-info="queryInfo" :com-type="item.selectType" :optype="item.optype" :shadow-close="false" @formChange="formChange" @close="backClose"></clue-popup></mars-view></mars-view></mars-view><mars-view v-if="list.length" class="logo-box"><mars-view class="logo-icon"></mars-view><mars-view class="logo-title">中国领先法律服务平台</mars-view></mars-view><mars-view v-if="isShowBottomFixedBtn" class="empty-box"></mars-view></mars-view>
    </div>
</template>

<script>
/* globals getApp swan */
import Topbar from "../../components/common/topbar.vue";
import log from '../../static/utils/ubcLog';
import { reqPathTo } from '../../static/utils/env';
import { request, getData } from '../../static/utils/request';
import header from "./components/header.vue";
import fixedBtn from "./components/fixedBtn.vue";
import knowledgeList from "./components/knowledgeList.vue";
import clueForm from "./components/clueForm.vue";
import cluePopup from "./components/cluePopup.vue";
import { inSightObserverDisconnects, inSightObservers } from '../../common/js/repeatExposureLog.js';
import Observer from '../../common/js/observer.js';
export default {
  components: {
    'top-bar': Topbar,
    'ui-header': header,
    'fixed-btn': fixedBtn,
    'knowledge-list': knowledgeList,
    'clue-form': clueForm,
    'clue-popup': cluePopup
  },
  computed: {
    isShowBottomFixedBtn() {
      // 表单配置底部固定按钮
      const formOption = this.list && this.list.filter(item => item.selectType === 'form_sub_new');
      const formBtn = formOption && formOption[0] && formOption[0].form_sub_new && formOption[0].form_sub_new.elements && formOption[0].form_sub_new.elements.filter(item => item.element_type === 'under_button');
      const isFormFixedBtn = formBtn && formBtn[0] && formBtn[0].button_show === 'constant';
      return this.isHasFixedBtn && !this.isFormBtnShow || isFormFixedBtn;
    }
  },
  watch: {
    isShowBottomPop(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
    isShowBackPop(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    }
  },
  data() {
    return {
      topBarStyle: {
        bgColor: 'custom',
        textColor: '#fff',
        logoUrl: 'https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-white.png'
      },
      queryInfo: {},
      styleType: false,
      from: '',
      // 活动组件列表
      list: [],
      // 活动id
      activityId: '',
      // 用户信息
      userInfo: {},
      // 是否有吸底按钮
      isHasFixedBtn: false,
      formInfo: {
        uname: '',
        phone: '',
        encrypedPhone: '',
        checkCode: '',
        type: '',
        desc: '',
        // 协议
        agreementApply: true,
        // 机构授权
        tpApply: true
      },
      // 头部轮播图
      headerSwiperList: [],
      // 表单提交按钮是否进入可视区
      isFormBtnShow: null,
      isSwan: "h5" === 'swan',
      isShowBackPop: false,
      isShowBottomPop: false,
      backCount: 0,
      isSuccessSubmit: false // 是否提交成功
    };
  },

  created() {
    this.onFormBtnShow = this.onFormBtnShow.bind(this);
    Observer.addObserver('isFormBtnShow', this.onFormBtnShow);
    (function (ctx) {
      this.queryInfo = ctx || {};
      this.from = this.queryInfo.fr || '';
      this.activityId = this.queryInfo.activityId || '';
      log.addKey && log.addKey({
        page: 'law-activity',
        fr: this.from,
        serverId: 17510,
        activityId: this.activityId
      });
      log.send({
        area: 'pv',
        action: 'pv'
      });
      this.init();
      this.getConsultInfo();
      // 小程序设置返回按钮颜色-默认
      this.$api.setNavigationBarColor({
        frontColor: '#ffffff',
        backgroundColor: '#fff'
      });
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  methods: {
    /**
     * 提交成功表单的回调
     */
    successSubmit() {
      this.isSuccessSubmit = true;
    },
    /**
     * 挽留弹窗的关闭
     */

    backClose() {
      this.isShowBackPop = false;
      window.history.back();
    },
    /**
     * 在配有返回拦截权限的情况下对于h5的未提交表单的返回拦截
     */

    onBrowserBack() {
      if (++this.backCount === 1 && this.isSuccessSubmit === false) {
        this.isShowBackPop = true;
        window.history.pushState(null, null, window.location.href);
      } else {
        window.history.back();
      }
    },
    /**
     * 页面滚动回掉
     * @param {e} event对象
     */

    pageScroll(e) {
      // 当滑动一定距离时 topbar 背景颜色变化
      if (e.scrollTop >= 10 && !this.styleType) {
        this.styleType = true;
        this.topBarStyle = {
          bgColor: '#fff',
          textColor: '#000',
          logoUrl: 'https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-new.png'
        };
        // 小程序设置返回按钮颜色用
        this.$api.setNavigationBarColor({
          frontColor: '#000000',
          backgroundColor: '#000'
        });
      } else if (e.scrollTop < 10 && this.styleType) {
        this.styleType = false;
        this.topBarStyle = {
          bgColor: 'custom',
          textColor: '#fff',
          logoUrl: 'https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-white.png'
        };
        // 小程序设置返回按钮颜色用
        this.$api.setNavigationBarColor({
          frontColor: '#ffffff',
          backgroundColor: '#fff'
        });
      }
    },
    /**
     * 表单页面初始化
     * @param {params} object 页面url所携带参数
     * @return {void}
     */

    init() {
      if (!this.activityId) {
        return;
      }
      const url = reqPathTo('info', {}, '', 'falv/pageconfig');
      request({
        url: url,
        method: 'get',
        loginNeeded: false,
        needBduss: true,
        data: {
          id: this.activityId
        }
      }).then(res => {
        if (!res || !res.data || +res.data.code !== 0) {
          return;
        }
        let info = res.data.data || {};
        this.list = info.components || [];
        this.list.forEach(item => {
          // 头部轮播
          if (item.selectType === 'barrages') {
            this.headerSwiperList = item.barrages || [];
          }
          // 表单提交
          else if (item.selectType === 'form_sub_new') {
            let prefix = item.form_sub_new && item.form_sub_new.point_prefix;
            item.optype = `${prefix}_active_page_form_${this.isSwan ? 'swan' : 'h5'}`;
          }
          // 是否配置吸底按钮
          else if (item.selectType === 'bottom_layer') {
            this.isHasFixedBtn = true;
            let prefix = item.bottom_layer && item.bottom_layer.point_prefix;
            item.optype = `${prefix}_active_page_pop_${this.isSwan ? 'swan' : 'h5'}`;
          }
          // 问答
          else if (item.selectType === 'legal_qa') {
            let prefix = item.legal_qa && item.legal_qa.point_prefix;
            item.optype = `${prefix}_active_page_QA_${this.isSwan ? 'swan' : 'h5'}`;
          }
          // 挽留弹窗
          else if (item.selectType === 'popup') {
            let prefix = item.popup && item.popup.point_prefix;
            item.optype = `${prefix}_poi_active_page_backPop_${this.isSwan ? 'swan' : 'h5'}`;
            // 具备挽留弹窗权限 & h5监听返回

            window.history.pushState(null, null, window.location.href);
            // 定时器防止初次pushState被监听
            setTimeout(() => {
              window.addEventListener('popstate', this.onBrowserBack, false);
            }, 300);
          }
        });
        this.$nextTick(() => {
          setTimeout(() => {
            this.addExposeObserve();
          }, 1000);
        });
      }).catch(() => {
        this.$api.showToast({
          title: '查询失败，请稍后重试',
          icon: 'none'
        });
      });
    },
    /**
     * 表单页面初始化
     * @param {params} object 页面url所携带参数
     * @return {void}
     */

    getConsultInfo() {
      const location = getApp().globalData.location || {};
      const url = reqPathTo('index', {}, '', 'law/formconsult');
      getData({
        url: url,
        data: {
          lat: location.lat || '',
          long: location.long || ''
        },
        loginNeeded: false,
        needBduss: true
      }).then(data => {
        let {
          encryped_phone,
          uname
        } = data || {};
        if (encryped_phone || uname) {
          this.formInfo = {
            ...this.formInfo,
            ...{
              phone: encryped_phone || '',
              encrypedPhone: encryped_phone || '',
              uname: uname || ''
            }
          };
        }
      });
    },
    /**
     *  曝光-监听函数
    */

    addExposeObserve() {
      // 不记录曝光的组件
      // botton_pop fix组件-小程序有bug,组件内部单独打点
      let blackList = ['barrages', 'botton_layer', 'popup'];
      let preformCom = ['legal_qa'];
      let formCom = ['form_sub_new'];
      this.list.forEach(item => {
        if (blackList.indexOf(item.selectType) < 0) {
          // 动态监听页面元素展示
          inSightObservers(`#${item.selectType}`, '', {}, [], true, true, true, {
            cb: res => {
              if (!res) {
                return;
              }
              if (this.isSwan && res.intersectionRect && res.intersectionRect.height > 0 || res.intersectionRatio > 0.2) {
                log.send({
                  area: 'activityModule',
                  action: 'show',
                  optype: item.optype || '',
                  part: item.selectType
                });
                // 表单提交组件
                if (formCom.indexOf(item.selectType) > -1) {
                  log.send({
                    serverId: 17260,
                    area: 'biaodan-retention',
                    action: 'show',
                    optype: item.optype || ''
                  });
                }
                // 表单提交-前置入库
                if (preformCom.indexOf(item.selectType) > -1) {
                  log.send({
                    serverId: 17260,
                    area: 'pref_guide',
                    action: 'show',
                    optype: item.optype || ''
                  });
                }
              }
            }
          });
        }
      });
    },
    /**
     * 底部弹窗是否展示
     */
    showPop(val) {
      this.isShowBottomPop = val;
    },
    /**
     * 表单切换
     * @param {object} args 参数
     */

    formChange(args) {
      if (!args) {
        return;
      }
      let {
        type,
        info = {}
      } = args || {};
      if (type === 'type') {
        this.formInfo.type = info.type;
      } else if (type === 'phone') {
        this.formInfo.phone = info.phone;
        this.formInfo.checkCode = info.checkCode;
      } else if (type === 'uname') {
        this.formInfo.uname = info.uname;
      } else if (type === 'desc') {
        this.formInfo.desc = info.desc;
      } else if (type === 'agreementApply') {
        this.formInfo.agreementApply = info.value;
      } else if (type === 'tpApply') {
        this.formInfo.tpApply = info.value;
      }
    },
    /**
     * 表单提交组件按钮-是否进入可视区
     */

    onFormBtnShow(args) {
      if (this.isShowBackPop === false) {
        this.isFormBtnShow = !!args;
      }
    },
    onPageScroll(e) {
      this.pageScroll(e);
    }
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      inSightObserverDisconnects();
      Observer.removeObserver('isFormBtnShow', this.onFormBtnShow);
      window.removeEventListener('popstate', this.onBrowserBack, false);
      document.body.style.overflow = '';
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.law-activity-box {
  overflow: auto;
  background: #f5f6f9;
  padding-bottom: constant(safe-area-inset-bottom);
  /* 兼容 iOS < 11.2 */
  padding-bottom: env(safe-area-inset-bottom);
  /* 兼容 iOS >= 11.2 */
}
.law-activity-box .form-sub-box {
  margin-top: -10.18vw;
}
.law-activity-box .logo-box {
  padding: 4.27vw 0 4.27vw;
}
.law-activity-box .logo-box .logo-icon {
  width: 15.7vw;
  height: 4.83vw;
  background: url('https://lvlin-base.cdn.bcebos.com/law/pages/home/lvlin-logo-new.png') no-repeat center / 100% 100%;
  margin: 0 auto;
}
.law-activity-box .logo-box .logo-title {
  margin-top: 3.38vw;
  color: #50525c;
  font-family: "PingFang SC";
  font-size: 3.38vw;
  font-style: normal;
  font-weight: 400;
  line-height: 3.38vw;
  text-align: center;
}
.law-activity-box .empty-box {
  height: 13.53vw;
}

</style>
